import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { CoreComponent } from './core.component'
import { UiLibraryModule } from '../ui-library/ui-library.module'
import { FormsModule } from '@angular/forms'
import { SelectionModule } from '../selection/selection.module'
import { CaseViewerModule } from '../case-viewer/case-viewer.module'
import { RouterModule } from '@angular/router'
import { CaseManagementModule } from '../case-management/case-management.module'
import { JobsModule } from '../jobs/jobs.module'
import { SharedModule } from '../shared/shared.module'

@NgModule({
    declarations: [CoreComponent],
    imports: [
        CommonModule,
        FormsModule,
        RouterModule,
        UiLibraryModule,
        CaseViewerModule,
        SelectionModule,
        CaseManagementModule,
        JobsModule,
        SharedModule,
    ],
})
export class CoreModule {}
